import Pako from "pako";

export const ARROWS_DESIGN = {
    legacy: 'legacy',
    vector: 'vector'
}

function toRadians(angle) {
    return angle * (Math.PI / 180);
}

const isUniqueProperty = (property, inputObject, del) => {

    //not changing when not set in mobile
    const uniqueArrayCommonDM = ['letterSpacing', 'lineHeight', 'shadow', 'textShadow', 'blur', 'left', 'right', 'center', 'bold', 'italic', 'underline', 'imgCrop', 'crop']
    if (uniqueArrayCommonDM.includes(property)) {
        return { unique: true, value: inputObject[property] }
    }

    if (property === 'position') {
        const position = {
            x: inputObject.position.x * del,
            y: inputObject.position.y * del,
            relativeX: inputObject.position.relativeX * del,
            relativeY: inputObject.position.relativeY * del
        }
        return { unique: true, value: position }
    }

    //shadow is complex unqiue property (counting separately)
    if (property === 'deltaX') {
        const radians = toRadians(inputObject.angle)
        const deltaX = Math.round(Math.sin(radians) * (inputObject.radius * del))
        return { unique: true, value: deltaX }
    }
    if (property === 'deltaY') {
        const radians = toRadians(inputObject.angle)
        const deltaY = Math.round(Math.sin(radians) * (inputObject.radius * del))
        return { unique: true, value: deltaY }
    }

    if (property === 'borderRadius' && typeof inputObject[property] != 'number') {
        const bRadius = {
            leftTop: inputObject.borderRadius.leftTop * del,
            rightTop: inputObject.borderRadius.rightTop * del,
            leftBottom: inputObject.borderRadius.leftBottom * del,
            rightBottom: inputObject.borderRadius.rightBottom * del,
        }
        return { unique: true, value: bRadius }
    }

    return { unique: false }
}

export const checkMobileProperty = (property = '', inputObject = {}, mobilePropertyAltName = '') => {
    if (mobilePropertyAltName != '') {
        return { exists: inputObject.hasOwnProperty(mobilePropertyAltName), property: mobilePropertyAltName }
    } else {
        let newProperty = property.split('')
        newProperty[0] = property[0].toUpperCase()
        newProperty = 'mobile' + newProperty.join('')
        return { exists: inputObject.hasOwnProperty(newProperty), property: newProperty }
    }
}

export const getRightPropertyValue = (desktopDims = { width: 100, height: 100 }, mobileDims = { width: 100, height: 100 }, property = '', isMobile = false, inputObject = {}, globalDiff = 1, mobilePropertyAltName = '', isInt = true, needMobileConvert = false) => {
    if (!isMobile) {
        return globalDiff != 1 && typeof inputObject[property] == 'number' ? inputObject[property] / globalDiff : inputObject[property]
    }

    const { exists, property: checkedMobileProperty } = checkMobileProperty(property, inputObject, mobilePropertyAltName)
    if (exists && !needMobileConvert) {
        return inputObject[checkedMobileProperty]
    }

    let del = 1
    let wmHD = (mobileDims.height / desktopDims.height)
    let wmWD = (mobileDims.width / desktopDims.width)

    if (wmHD < wmWD) del = wmHD
    else del = wmWD

    const { unique, value } = isUniqueProperty(property, inputObject, del)

    if (unique) {
        return value
    }

    let returnValue = inputObject[property] * del
    if (isInt) {
        returnValue = inputObject[property] > 0 ? clampValue(parseInt(returnValue), 1, inputObject[property]) : parseInt(returnValue)
    } else {
        returnValue = parseFloat(inputObject[property] * del)
    }

    return returnValue

}

export const convertShadowToRPVFormat = (shadow) => {
    const newShadowObject = {
        deltaX: shadow.x,
        deltaY: shadow.x,
        blur: shadow.blur,
        radius: shadow.distance,
        angle: shadow.angle,
        color: shadow.color
    }

    return newShadowObject
}

export const PLATFORM = {
    iphone: 'iphone',
    win32: 'win32',
    macos: 'macos',
    linux: 'linux',
    NONE: 'NONE'
}

export const platformHelper = {
    getPlatform: () => {
        let platform = navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform;
        // console.log('getPlatform', platform)
        if (platform != null && platform != undefined) {
            platform = platform.toLowerCase();

            if (platform.includes('mac')) {
                return PLATFORM.macos
            }

        } else {
            return PLATFORM.NONE;
        }

        return PLATFORM[platform] ? PLATFORM[platform] : PLATFORM.NONE;
    }
};


export const convertTextAlignToFlex = (textAlign, reversed = false) => {
    switch (textAlign) {
        case 'left':
            return reversed ? 'flex-end' : 'flex-start';
        case 'right':
            return reversed ? 'flex-start' : 'flex-end';
        case 'center':
            return 'center';
    }
}

export const getSVGStructFromBuffer = (buffer) => {
    const svgUint8Array = Uint8Array.from(atob(buffer), c => c.charCodeAt(0)); // For browser environments
    const decompressedData = Pako.inflate(svgUint8Array);
    // Convert decompressed data to string if needed
    const svgString = new TextDecoder().decode(decompressedData);
    const svgObject = JSON.parse(svgString);
    return svgObject
}

export const clampValue = (value, min, max) => {
	return Math.max(min, Math.min(value, max))
}

export const remapValue = (value, inMin, inMax, outMin, outMax) => {
	const inRange = inMax - inMin;
	const outRange = outMax - outMin;
	const valueSubMin = clampValue(value, inMin, inMax) - inMin;
	const fraction = valueSubMin / inRange;
	return outMin + fraction * outRange;
}

export const disableSwitchOptions = (parentElement = HTMLBaseElement.prototype, valuesToDisable = [])  => {
    if (parentElement) {
        const inputs = parentElement.querySelectorAll(`input`)
        for (let input of inputs) {
            if (valuesToDisable.includes(input.defaultValue)) {
                input.disabled = true
            }
        }
    }
}

export const EDIT_SLIDE_HEIGHT = 767

export const GlobalTimerManager = {
    STORAGE_PREFIX: 'GlobalTimerManager',
    setTimer: function(callback, delay, name) {
        if (window.GlobalTimerManager.timers[name]) {
            return
        }

        if (!window.GlobalTimerManager) {
            window.GlobalTimerManager = {
                timers: {}
            }
        }

        const timerTimeLeft = localStorage.getItem(`${this.STORAGE_PREFIX}-${name}`)
        if (!timerTimeLeft) {
            localStorage.setItem(`${this.STORAGE_PREFIX}-${name}`, JSON.stringify({startTime: Date.now(), delay: delay}))
        }

        window.GlobalTimerManager.timers[name] = setInterval(() => {
            const timeLeft = localStorage.getItem(`${this.STORAGE_PREFIX}-${name}`)
            if (timeLeft) {
                const parsedTimeLeft = JSON.parse(timeLeft)
                const timeDiff = Date.now() - parsedTimeLeft.startTime
                if (timeDiff >= parsedTimeLeft.delay) {
                    callback()
                    this.clearTimer(name)
                }
            }
        }, 1000)
    },
    clearTimer: (name) => {
        if (name) {
            window.GlobalTimerManager.timers[name] && clearInterval(window.GlobalTimerManager.timers[name])
            localStorage.removeItem(`${GlobalTimerManager.STORAGE_PREFIX}-${name}`)
        }
    },
    continueTimer: function (callback, name) {
        if (!window.GlobalTimerManager) {
            window.GlobalTimerManager = {
                timers: {}
            }
        }
        const timerTimeLeft = localStorage.getItem(`${this.STORAGE_PREFIX}-${name}`)
        if (timerTimeLeft) {
            window.GlobalTimerManager.timers[name] = setInterval(() => {
                const timeLeft = localStorage.getItem(`${this.STORAGE_PREFIX}-${name}`)
                if (timeLeft) {
                    const parsedTimeLeft = JSON.parse(timeLeft)
                    const timeDiff = Date.now() - parsedTimeLeft.startTime
                    if (timeDiff >= parsedTimeLeft.delay) {
                        callback()
                        this.clearTimer(name)
                    }
                }
            }, 1000)
        }
    }
}